import { SignallerDTO } from '@/openapi';
import styles from './SignallerList.module.css';
import SignallerCard from '../SignallerCard';
import { useTranslation } from 'react-i18next';

interface SignallerListProps {
	data: SignallerDTO[];
	title: string;
	payFunction: 'pay' | 'reward';
	onPaymentSuccess?: () => void; // Callback per aggiornare la lista post pagamento
}

const SignallerList = (props: SignallerListProps) => {
	const { t } = useTranslation();

	return (
		<div className={styles.signallerListContainer}>
			<h3 className={styles.listTitle}>{props.title}</h3>
			<div className={styles.scrollableList}>
				{props.data.length > 0 ? (
					props.data.map((signaller) => (
						<SignallerCard
							key={signaller.id}
							signaller={signaller}
							payFunction={props.payFunction}
							onPaymentSuccess={props.onPaymentSuccess}
						/>
					))
				) : (
					<div className={styles.emptyState}>
						<p>{t('adminPage.signaller.noData')}</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default SignallerList;
